import React from 'react';
import {Box, Typography, List, ListItem, ListItemText, Chip, Stack, Paper} from "@mui/material";

const getTagColor = (tag) => {
    const colorMap = {
        'typ': '#2196f3',        // blue
        'adssquared': '#9c27b0', // purple
        'clarity': '#9c27b0',    // purple
        'n2s': '#ff9800',        // orange
        // Red highlight for specific tags
        'servelink': '#f44336',  // red
        'cbs': '#f44336',        // red
        'benrif': '#f44336',     // red
        'nexify': '#f44336',     // red
        'youniv': '#f44336',     // red
    };

    // For yahoo_pixel tags
    if (tag.includes('yahoo_pixel')) {
        return '#4caf50';        // green

    }

    return colorMap[tag] || '#757575'; // default gray
};


const Result = ({data}) => {
    const totalJumps = data.jumps.length;
    
    // For the global tags (rendered at the bottom), extract any alert tags.
    // They will be rendered at the top of the Paper instead.
    const globalAlertTags = data.tags.filter(tag => tag.startsWith("ALERT:"));
    const normalGlobalTags = data.tags.filter(tag => !tag.startsWith("ALERT:"));

    return (
        <Box sx={{mt: 2}}>
            <Paper elevation={3} sx={{p: 3, mb: 3, backgroundColor: '#f8f9fa'}}>
                {/* Global Alerts: if any global tag starts with "ALERT:" display it first */}
                {globalAlertTags.length > 0 && (
                    <Stack direction="row" spacing={1} sx={{mb: 2}}>
                        {globalAlertTags.map((tag, index) => (
                            <Chip
                                key={`global-alert-${index}`}
                                label={tag.replace("ALERT:", "").trim()}
                                size="small"
                                sx={{
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    fontWeight: 500
                                }}
                            />
                        ))}
                    </Stack>
                )}

                <Typography variant="h6" gutterBottom color="primary" sx={{mt: 4}}>
                    Redirects ({totalJumps} {totalJumps === 1 ? 'jump' : 'jumps'})
                </Typography>
                <List sx={{backgroundColor: '#fff', borderRadius: 1, border: '1px solid #e0e0e0'}}>
                    {data.jumps.map((jump, index) => {
                        // Separate alert tags from the rest – alert tags will be rendered at the top.
                        const alertTags = jump.tags.filter(tag => tag.startsWith("ALERT:"));
                        const normalTags = jump.tags.filter(tag => !tag.startsWith("ALERT:"));
                        return (
                            <ListItem 
                                key={index} 
                                sx={{
                                    flexDirection: 'column', 
                                    alignItems: 'flex-start',
                                    borderBottom: index < data.jumps.length - 1 ? '1px solid #e0e0e0' : 'none',
                                    position: 'relative',
                                    pl: 7
                                }}
                            >
                                <Typography 
                                    sx={{
                                        position: 'absolute',
                                        left: 16,
                                        top: 16,
                                        width: 24,
                                        height: 24,
                                        borderRadius: '50%',
                                        backgroundColor: 'primary.main',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    {index + 1}
                                </Typography>
                                {alertTags.length > 0 && (
                                    <Stack direction="row" spacing={1} sx={{mt: 1}}>
                                        {alertTags.map((tag, tagIndex) => (
                                            <Chip 
                                                key={`alert-${tagIndex}`} 
                                                label={tag.replace("ALERT:", "").trim()}
                                                size="small"
                                                sx={{
                                                    backgroundColor: '#f44336',
                                                    color: 'white',
                                                    '& .MuiChip-label': {
                                                        fontWeight: 500
                                                    }
                                                }}
                                            />
                                        ))}
                                    </Stack>
                                )}
                                <ListItemText 
                                    primary={jump.url} 
                                    sx={{'& .MuiListItemText-primary': {wordBreak: 'break-all'}}}
                                />
                                {normalTags.length > 0 && (
                                    <Stack direction="row" spacing={1} sx={{mt: 1}}>
                                        {normalTags.map((tag, tagIndex) => (
                                            <Chip 
                                                key={`normal-${tagIndex}`} 
                                                label={tag}
                                                size="small"
                                                sx={{
                                                    backgroundColor: getTagColor(tag),
                                                    color: 'white',
                                                    '& .MuiChip-label': {
                                                        fontWeight: 500
                                                    }
                                                }}
                                            />
                                        ))}
                                    </Stack>
                                )}
                            </ListItem>
                        );
                    })}
                </List>

                <Typography variant="h6" gutterBottom color="primary" sx={{mt: 4}}>
                    Tags ({normalGlobalTags.length})
                </Typography>
                <Stack 
                    direction="row" 
                    spacing={1} 
                    flexWrap="wrap" 
                    useFlexGap 
                    sx={{
                        gap: 1,
                        p: 2,
                        backgroundColor: '#fff',
                        borderRadius: 1,
                        border: '1px solid #e0e0e0'
                    }}
                >
                    {normalGlobalTags.map((tag, index) => (
                        <Chip 
                            key={index} 
                            label={tag}
                            sx={{
                                backgroundColor: getTagColor(tag),
                                color: 'white',
                                '& .MuiChip-label': {
                                    fontWeight: 500
                                }
                            }}
                        />
                    ))}
                </Stack>
            </Paper>
        </Box>
    );
};

export default Result; 